<template>
    <div class="content md">
        <system-admin type="buddha"></system-admin>
    </div>
</template>

<script>
    import SystemAdmin from "../../layouts/SystemAdmin";
    export default {
        name: "BuddhismAdmin",
        components: {
            SystemAdmin
        }
    }
</script>

<style scoped>

</style>
